import React from 'react'
import { Hidden } from '@material-ui/core'
import Mobile from './Mobile'
import Desktop from './Desktop'

export default ({ inbox }) => (
  <div style={{ width: '100%' }}>
    <Hidden smDown>
      <Desktop inbox={inbox} />
    </Hidden>
    <Hidden mdUp>
      <Mobile inbox={inbox} />
    </Hidden>
  </div>
)
